import React from 'react';
import { spacing } from '../../theme';
import { Stack } from '../Stack';
import { MdOutlineArrowBackIosNew, MdOutlineArrowForwardIos } from "react-icons/md";
import { Button } from '@chakra-ui/react';
import { servicebookingFlowStore } from '../../store/ServiceBookingFlowStore';
import { observer } from 'mobx-react-lite'; // Import observer from mobx-react-lite

export interface TimePickerNavigationProps {
  /**
   * The handler that's called when navigating to the previous set of dates.
   */
  onPrev: () => void;
  /**
   * The handler that's called when navigating to the next set of dates.
   */
  onNext: () => void;
  /**
   * Optionally hide the previous button. Useful if you don't want to allow users to navigate prior to today's date.
   */
  showPrev?: boolean;
  /**
   * Optionally hide the next button. Useful if there's a limit to the range of dates you can show.
   */
  showNext?: boolean;
}

// Wrap the component with observer
export const TimePickerNavigation = observer((props: TimePickerNavigationProps) => {
  const { onPrev, onNext, showPrev = true, showNext = true } = props;

  // Safely access colorScheme with fallback values
  const buttonBgColor = servicebookingFlowStore.isServiceBooking && 
    servicebookingFlowStore.configurationDetails?.colorScheme?.buttonBg 
    ? servicebookingFlowStore.configurationDetails.colorScheme.buttonBg 
    : "#B92F2F";

  return (
    <Stack
      direction="row"
      style={$headerContainer}
    >
      <Stack
        direction="row"
        style={$navigationContainer}
      >
        {!!showPrev && (
          <Button
            leftIcon={
              <MdOutlineArrowBackIosNew />
            }
            onClick={onPrev}
            style={$prevButtonStyle}
            borderRadius={'full'}
            size="sm" fontSize="xs"
            variant="outline"
            border={'2px'}
            borderColor={buttonBgColor}
            color={buttonBgColor}
            _hover={{ bg: buttonBgColor, color: "white" }}
          >Prev </Button>
        )}
        {!!showNext && (
          <Button
            rightIcon={<MdOutlineArrowForwardIos />}
            onClick={onNext}
            style={$nextButtonStyle}
            borderRadius={'full'}
            size="sm" fontSize="xs"
            border={'2px'}
            variant="outline"
            borderColor={buttonBgColor}
            color={buttonBgColor}
            _hover={{ bg: buttonBgColor, color: "white" }}
          >Next </Button>
        )}
      </Stack>
    </Stack>
  );
});

const $headerContainer: React.CSSProperties = {
  justifyContent: 'space-between',
  marginBottom: spacing.xs,
  marginTop: spacing.md,
};

const $navigationContainer: React.CSSProperties = {
  flex: 1,
  justifyContent: 'space-between',
};

const $prevButtonStyle: React.CSSProperties = {
  minHeight: 0,
  marginRight: 'auto',
  paddingTop: 0,
};

const $nextButtonStyle: React.CSSProperties = {
  minHeight: 0,
  marginLeft: 'auto',
  paddingTop: 0,
};